/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  update(id, data) {
    // Always nest under agent[]; use FormData whenever a File is present so
    // ActiveStorage receives multipart upload correctly.
    const hasFile = Object.values(data || {}).some(
      value => typeof File !== 'undefined' && value instanceof File
    );

    if (hasFile) {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        const value = data[key];
        if (value === undefined) return;
        if (value === null) {
          if (key === 'custom_role_id') {
            formData.append('agent[custom_role_id]', '');
          }
          return;
        }

        if (key === 'avatar' && value instanceof File) {
          formData.append('agent[avatar]', value);
          return;
        }

        if (key === 'feature_permissions' && Array.isArray(value)) {
          if (value.length === 0) {
            formData.append('agent[feature_permissions][]', '');
            return;
          }
          value.forEach(permission => {
            formData.append('agent[feature_permissions][]', permission);
          });
          return;
        }

        formData.append(`agent[${key}]`, value);
      });

      return axios.patch(`${this.url}/${id}`, formData);
    }

    return super.update(id, data);
  }

  destroyAvatar(agentId) {
    return axios.delete(`${this.url}/${agentId}/avatar`);
  }

  conversationMetrics(agentId) {
    return axios.get(`${this.url}/${agentId}/conversation_metrics`);
  }
}

export default new Agents();
